<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">分配角色</div>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0;">
        <span class="small_title">基本信息</span>
        <el-form ref="form" :model="form" label-width="80px" style="margin-top:20px;">
          <el-row>
            <el-col :span="8" :offset="2">
              <el-form-item label="用户昵称">
                <el-input v-model="form.nickName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="2">
              <el-form-item label="登录账号">
                <el-input  v-model="form.userName" disabled />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span class="small_title">角色信息</span>
        <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table v-loading="loading" :row-key="getRowKey" ref="table" @selection-change="handleSelectionChange" :data="roles.slice((pageNum-1)*pageSize,pageNum*pageSize)">
                <el-table-column type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
                <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
                <el-table-column label="角色编号" align="center" prop="roleId" />
                <el-table-column label="角色名称" align="center" prop="roleName" />
                <el-table-column label="权限字符" align="center" prop="roleKey" />
                <el-table-column label="创建时间" align="center" prop="createTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.createTime) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageSize"  
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
            v-show="total>0"
          ></el-pagination>
        </zj-layout-footer>
        <el-form label-width="100px">
          <el-form-item style="text-align: center;margin-left:-120px;margin-bottom:0px;">
            <el-button type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="close()">返回</el-button>
          </el-form-item>
        </el-form>
      </zj-layout-main>
    </zj-layout-container>
       <!-- 密码二次确认框 -->
    <el-dialog :title="title2" :visible.sync="isShowPasswordDialog" width="600px" append-to-body>
      <el-form ref="form2" :model="form2" :rules="rules2" label-width="80px" v-if="isShowPasswordDialog">    
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="用户名称"
              prop="loginName"
            >
              <el-input
                v-model="form2.loginName"
                placeholder="请输入用户名称"
                maxlength="30"
                 disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form2.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPassword">确 定</el-button>
        <el-button @click="cancel2">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserRole, updateUserRole } from "@/api/system/permission/user";
import { login } from "@/api/system/permission/login";
export default {
  name: "UserRoleView",
  controller: "UI",
  action: "UserRoleView",
  data() {
    return {
       // 遮罩层
      loading: true,
      // 分页信息
      total: 0,
      pageNum: 1,
      pageSize: 10,
      // 选中角色编号
      roleIds:[],
      // 角色信息
      roles: [],
      // 用户信息
      form: {},
            // 弹出层标题
      title2: "请输入密码",
      isShowPasswordDialog:false,
      form2:{
        loginName: sessionStorage.getItem("userName"),
        password:"",
      },
      rules2: {
        loginName: [
          {
            required: true,
            message: "用户名称不能为空",
            pattern: "[^ \x22]+",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "用户密码不能为空",
            trigger: "blur",
          }
        ],
      },
      confirmType:""

    };
  },
  created() {
    const userId = this.$route.query && this.$route.query.userId;
    if (userId) {
      this.loading = true;
      getUserRole(userId).then((response) => {
        this.form = response.data.user;
        this.roles = response.data.roles;
        this.total = this.roles.length;
        this.$nextTick(() => {  //设置选中状态
          this.roles.forEach((row) => {
            if (row.flag) {
              this.$refs.table.toggleRowSelection(row);
            }
          });
        });
        this.loading = false;
      });
    }
  },
  methods: {
    // 单击选中行数据
    clickRow(row) {
      this.$refs.table.toggleRowSelection(row);  //切换行选中状态
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.roleIds = selection.map((item) => item.roleId);
    },
    // 保存选中的数据编号
    getRowKey(row) {
      return row.roleId;
    },
    // 提交
    submitForm() {
      const userId = this.form.userId;
      const roleIds = this.roleIds.join(",");
      if(global.$config.app.project=="hongqifang"&&!this.isSecondConfirm){
        this.isShowPasswordDialog = true;
        return
      }
      updateUserRole({ userId: userId, roleIds: roleIds }).then((response) => {
        if(response.code==200||response.code==0){
          this.$message({type: "success", message: "授权成功"});
          this.close();
        }
        
      });
    },
    // 返回
    close() {
      this.$router.go(-1);
    },

    // 点击每页显示的条数
    handleSizeChange(val){
      this.pageSize = val;
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.pageNum = val;
    },
    confirmPassword(){
      let that = this;
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          login(this.form2).then((res) => {
            console.log("登录结果",res)
            if(res.code==0||res.code==200){
              that.isSecondConfirm=true;
               that.cancel2();
               if(that.confirmType=="dell"){ 
                //  delUser(that.currentRow.userId).then(res=>{
                //    console.log("删除res",res)
                //    if(res.code==200){
                //      that.confirmType="";
                //      that.getList()
                //    }else{
                //      that.confirmType="";
                //    }
                //  })
               }else{
                  that.submitForm()
               }
  
            }
          });
        }
      });
    },
    // 取消按钮
    cancel2() {
      this.isShowPasswordDialog = false;
      this.form2.password = "";
    },
  },
};
</script>
<style scoped>
.small_title{
  font-weight: bold;
  border-bottom: 0.1rem dashed #2bc2ff;
  color: #2bc2ff;
  height: 4rem;
  position: relative;
}
</style>